import { sendCategoryFilterEvent } from '../../utils/event-triggers';
import { ajax } from '../../utils/ajax-handler';
import { get } from '../../utils/object-helpers';

export default class {
    onCreate(input) {
        const updateLabel = get(input, 'label.textSpans.0.text', '');
        const shipToLabel = get(input, 'minView.shipToLabel.textSpans.0.text', '');
        const currentZip = get(input, 'minView.zipCode.label.textSpans.0.text', '');
        let formHeader = '';
        let miniLabel = updateLabel;
        if (shipToLabel.length > 0 && currentZip.length > 0) {
            formHeader = updateLabel;
            miniLabel = shipToLabel;
        }
        this.countries = get(input, 'maxView.countryGroup.entries', []);
        this.countrySelected = this.countries.find((country) => country.selected);
        this.zipCodeParamKey = get(input, 'maxView.zipParamKey', '');
        this.countryParamKey = get(input, 'maxView.countryGroup.paramKey', '');
        this.baseUrl = get(input, 'maxView.goButton.action.URL', '');
        this.shipToLabel = shipToLabel;
        this.updateLabel = updateLabel;
        this.toggleButtonSelector = '.str-ship-location__button';
        const zipCodeDisable = get(this.countrySelected, 'fieldActions.0.doReact', '') === 'DISABLED';
        this.state = {
            showClass: 'mini',
            maskClass: 'str-ship-location-mask',
            errorMsg: '',
            zipCodeDisable: zipCodeDisable,
            currentZip: currentZip,
            zipCodeValue: get(input, 'maxView.zipParamValue', ''),
            formHeader: formHeader,
            miniLabel: miniLabel,
            selected: get(this.countrySelected, 'paramValue', '')
        };
    }
    onMount() {
        const zipCodeComp = this.getComponent('zipcode');
        if (zipCodeComp) {
            this.zipCodeInput = zipCodeComp.getEl('input');
            this.countryValue = get(this.countrySelected, 'paramValue', '');
            document.addEventListener('toggle-location-popup', () => { // Dispatched from str-status
                this.toggleLocationPopup();
            });
        }
    }
    toggleLocationPopup(event) {
        this.state.showClass = this.state.showClass === 'mini' ? 'max' : 'mini';
        this.state.maskClass = this.state.maskClass === 'str-ship-location-mask__show' ?
            'str-ship-location-mask' : 'str-ship-location-mask__show';
        document.querySelector(this.toggleButtonSelector)
            .setAttribute('aria-expanded', this.state.showClass === 'mini' ? 'false' : 'true');
        event?.originalEvent.stopPropagation();
    }
    closePopup() {
        document.querySelector(this.toggleButtonSelector).setAttribute('aria-expanded', 'false');
        this.state.errorMsg = '';
        if (this.state.showClass !== 'mini') {this.state.showClass = 'mini';}
        if (this.state.maskClass === 'str-ship-location-mask__show') {this.state.maskClass = 'str-ship-location-mask';}
    }
    maskClick(event) {
        if (this.state.showClass === 'max' && event.target.classList &&
            !event.target.classList.contains('str-ship-location-selection')) {
            this.closePopup();
        }
    }
    selectCountry(event) {
        this.countryValue = event.selected[0];
        this.state.selected = this.countryValue;
        this.state.zipCodeDisable = get(this.countries[event.index], 'fieldActions.0.doReact', '') === 'DISABLED';
        this.state.zipCodeValue = '';
    }
    validateZip(event) {
        event.preventDefault();
        event.stopPropagation();
        const zipCodeValue = this.zipCodeInput.value;
        if (zipCodeValue.trim().length === 0) {
            this.moduleUpdate(zipCodeValue);
        } else {
            ajax({
                url: appendParams(this.zipCodeParamKey, zipCodeValue, this.countryParamKey, this.countryValue, true)
            }, {
                successCallBack: (resp) => {
                    if (!resp.success) {
                        this.handleInvalidZip(resp.message, zipCodeValue);
                    } else {
                        this.moduleUpdate(zipCodeValue);
                    }
                },
                errorCallBack: (err) => {
                    const message = err.message;
                    this.handleInvalidZip(message, zipCodeValue);
                }
            },
            3000);
        }
    }
    moduleUpdate(zipCodeInput) {
        this.closePopup();
        this.state.selected = this.countryValue;
        this.state.currentZip = zipCodeInput;
        this.state.zipCodeValue = zipCodeInput;
        this.state.formHeader = this.updateLabel;
        this.state.miniLabel = zipCodeInput.length === 0 ? this.updateLabel : this.shipToLabel;
        this.zipCodeInput.removeAttribute('aria-describedby');

        const url = appendParams(this.zipCodeParamKey, zipCodeInput, this.countryParamKey, this.countryValue);
        sendCategoryFilterEvent({ url });
    }
    handleInvalidZip(message) {
        document.querySelector('.str-ship-location-selection__error').innerHTML = message;
        this.zipCodeInput.setAttribute('aria-invalid', true);
        this.zipCodeInput.setAttribute('aria-describedby', 'str-ship-location-selection__error');
        this.zipCodeInput.focus();
    }
}
function appendParams(zipCodeParamKey, zipCodeInput, countryParamKey, countryValue, isValidation) {
    const link = document.createElement('a');
    link.href = window.location.href;
    let queryString;
    if (link.search) {
        if (link.search.indexOf('_fcid') !== -1) {
            const urlParams = new URLSearchParams(link.search);
            urlParams.delete('_fcid');
            urlParams.delete('_stpos');
            queryString = `?${urlParams.toString()}&`;
        } else {
            queryString = `${link.search}&`;
        }
    } else {
        queryString = `?`;
    }
    const params = [];
    if (!zipCodeInput !== undefined && zipCodeInput.length !== 0) {
        params.push(`${zipCodeParamKey}=${zipCodeInput}`);
    }
    params.push(`${countryParamKey}=${countryValue}`);
    if (isValidation) {
        params.push('_validateRequest=true');
    }
    queryString += params.join('&');
    return `https://${window.location.host}${link.pathname}${queryString}`;
}
